import { render, staticRenderFns } from "./InstructionMinimis.vue?vue&type=template&id=6f8a0d21&"
import script from "./InstructionMinimis.vue?vue&type=script&lang=js&"
export * from "./InstructionMinimis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports